import { motion } from "framer-motion";
import { IMAGES } from "../lib/images";
import { Reveal } from "./Reveal";

const certs = [
  { code: "ISO 9001", label: "Sistema Qualità Certificato" },
  { code: "CE MARK", label: "Conformità Europea" },
  { code: "TÜV", label: "Ente Certificatore" },
];

const stats = [
  { value: "±0.005", unit: "mm", label: "Tolleranza tipica" },
  { value: "5", unit: "assi", label: "Centri di lavoro CNC" },
  { value: "1985", unit: "", label: "Anno di fondazione" },
];

export const Quality = () => (
  <section id="qualita" data-testid="quality" className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      <Reveal>
        <div className="relative border border-white/10 overflow-hidden aspect-[4/5]">
          <img src={IMAGES.cobiMetrology} alt="Sala metrologica e collaudo Cobi Meccanica" className="w-full h-full object-cover opacity-90" />
          <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 to-transparent" />
          <div className="absolute bottom-6 left-6 font-mono text-xs uppercase tracking-widest text-zinc-300">
            Sala metrologica · Macchine tridimensionali
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-red-600" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-red-600">Qualità & Collaudo</span>
          </div>
          <h2 className="font-display font-black uppercase text-4xl md:text-6xl tracking-tighter leading-none mb-8">
            Controllo<br />senza margini
          </h2>
          <p className="text-lg text-zinc-400 leading-relaxed max-w-lg mb-12">
            Le nostre sale metrologiche consentono collaudi intermedi, controlli dimensionali e
            certificazioni finali. Ogni componente lascia lo stabilimento verificato secondo standard rigorosi.
          </p>
        </Reveal>

        <div className="grid grid-cols-3 gap-4 mb-12">
          {stats.map((st, i) => (
            <Reveal key={st.label} delay={i * 0.1}>
              <div data-testid={`stat-${i}`} className="border-l border-white/15 pl-4">
                <div className="font-display font-black text-3xl md:text-4xl tracking-tight">
                  {st.value}<span className="text-red-600 text-lg ml-1">{st.unit}</span>
                </div>
                <div className="font-mono text-[11px] uppercase tracking-wider text-zinc-500 mt-2">{st.label}</div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="flex flex-wrap gap-3">
            {certs.map((c) => (
              <motion.div
                key={c.code}
                data-testid={`cert-${c.code.replace(/\s/g, "-").toLowerCase()}`}
                whileHover={{ y: -4 }}
                className="border border-white/15 px-5 py-4 hover:border-red-600 transition-colors"
              >
                <div className="font-display font-bold text-lg tracking-tight">{c.code}</div>
                <div className="font-mono text-[10px] uppercase tracking-wider text-zinc-500 mt-1">{c.label}</div>
              </motion.div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>

    <Reveal>
      <div className="mt-20 border border-white/10 bg-zinc-900/40 p-8 md:p-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-red-600">Partnership</span>
          <h3 className="font-display font-black uppercase text-3xl md:text-5xl tracking-tighter mt-3">
            Fornitore Ufficiale <span className="text-red-600">Ducati</span>
          </h3>
        </div>
        <p className="max-w-md text-zinc-400 leading-relaxed">
          Un rapporto di fiducia costruito sulla precisione, che ci lega alle eccellenze del motorsport
          e alle realtà industriali più esigenti del territorio.
        </p>
      </div>
    </Reveal>
  </section>
);
